import React, { useState, useMemo } from "react";
import {
  Button,
} from '@lockerpm/design';

import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
} from '../../../../../components'

import {
} from '../../../../../utils/common'

import {
  ImportOutlined
} from "@ant-design/icons";

import ImportFormData from "./ImportFormData";

const Import = (props) => {
  const {
    className = '',
  } = props;
  const { t } = useTranslation();
  const [formVisible, setFormVisible] = useState(false);

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl">
          {t('import_export.import')}
        </p>
        <Button
          type='primary'
          icon={<ImportOutlined />}
          onClick={() => setFormVisible(true)}
        >
          {t('button.import')}
        </Button>
      </div>
      <p className="mt-1">
        {t('import_export.import_description')}
      </p>
      <ImportFormData
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      />
    </div>
  );
}

export default Import;
